import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-363" data-mp="29lgguz85bwno">
      <SEO title="About | KittyPot" description="The story behind KittyPot — a shared expense tracker that helps groups split costs fairly and keep track of who owes what." ogTitle="About KittyPot" ogDescription="Why we built KittyPot, and what it does for your group." path="/about" data-id="element-364" data-mp="2egm35z5gndca" />
      <Navbar data-id="element-365" data-mp="2x8om5h5kr5pp" />
      <main className="pt-32 pb-24" data-id="element-366" data-mp="2x8eu7o0yyohd">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-367" data-mp="2x7d8mpmbujle">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-368" data-mp="1gtwrsyovbodr">
            About KittyPot
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-369" data-mp="1luu793ihu4bk">
            <p data-id="element-370" data-mp="1uh0ajvr3z1n6">
              KittyPot started with a simple question: how do groups keep things
              fair when one person pays and everyone else needs to settle up?
            </p>
            <p data-id="element-371" data-mp="23iztitloofsr">
              The idea was sparked during a family conversation about organising
              a kitty for a bike tour. With contactless replacing cash, keeping
              track of shared spending had quietly become harder, not easier.
            </p>
            <p data-id="element-372" data-mp="28hkrsnhdkpek">
              So we built KittyPot around the bit that actually causes friction:
              the record. You create a kitty, everyone adds what they spend, and
              KittyPot keeps a clear, shared view of who owes what. When it is
              time to settle, people pay each other directly — KittyPot does not
              hold or move anyone's money.
            </p>
            <p data-id="element-373" data-mp="2w4sztd66ucka">
              It is deliberately simple. Splitting costs, tracking shared
              spending and knowing where you stand should take seconds, not a
              spreadsheet and a group chat.
            </p>
            <p data-id="element-374" data-mp="1svq74lo6bqpg">
              We are a small UK team, and we are building KittyPot with the
              people who use it. If something is missing or awkward, we would
              genuinely like to hear about it.
            </p>
            <p className="font-medium mt-8" data-id="element-375" data-mp="22nm57wq9fgto">Benjamin Elliott, Founder</p>
          </div>
        </div>
      </main>
      <Footer data-id="element-376" data-mp="27kuqw7ama2zo" />
    </div>;
}